import { pantryColors } from '@pantry/ui'
import React from 'react'

const p = pantryColors

interface StarRatingProps {
  value: number
  readOnly?: boolean
  size?: number
  onChange?: (value: number) => void
}

export const StarRating: React.FC<StarRatingProps> = ({
  value,
  readOnly = true,
  size = 14,
  onChange,
}) => (
  <div style={{ display: 'inline-flex', gap: 2 }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <span
        key={n}
        role={readOnly ? undefined : 'button'}
        aria-label={readOnly ? undefined : `${n} star`}
        onClick={readOnly ? undefined : () => onChange?.(n)}
        style={{ cursor: readOnly ? 'default' : 'pointer', lineHeight: 0 }}
      >
        <svg
          viewBox="0 0 20 20"
          width={size}
          height={size}
          fill={n <= value ? '#F59E0B' : p.gray[200]}
        >
          <path d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.9l-5.2 2.61.99-5.79-4.21-4.1 5.82-.85z" />
        </svg>
      </span>
    ))}
  </div>
)
